import React from "react";

interface LabelProps {
  children: React.ReactNode;
  className?: string;
}

const Label: React.FC<LabelProps> = ({ children, className }) => {
  const defaultColor = className ? "" : "text-[#252525]";
  return (
    <span className={`block ${defaultColor} w-full ${className || ""}`}>
      {children}
    </span>
  );
};

export default Label;
